import {useNavigate} from 'react-router';

import {MODAK_URL} from '@/constants';
import {useAmplifyAuth} from '@/hooks';
import {WEB_VIEW_MESSAGES} from '@/services/webview/constants';
import {WebViewService} from '@/services/webview/WebViewService';
import {isProduction} from '@/utils/environment';

interface ILogoutAdditionalParams {
  kycStatus?: string;
  customTitle?: string;
  customMessage?: string;
}

export const useAuthFunctions = () => {
  const isProd = isProduction;
  const navigate = useNavigate();
  const {clearData, signOut} = useAmplifyAuth();

  const logout = async (
    refresh?: boolean,
    params?: ILogoutAdditionalParams,
  ) => {
    clearData();

    if (!isProd && !refresh) {
      goToAuth();
      return;
    }

    if (
      WebViewService.isWebViewActive() &&
      typeof window.ReactNativeWebView !== 'undefined' &&
      window.ReactNativeWebView
    ) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          status: WEB_VIEW_MESSAGES.TIME_OUT,
          kycStatus: params?.kycStatus,
          customTitle: params?.customTitle,
          customMessage: params?.customMessage,
        }),
      );
    }

    await signOut();

    if (refresh) {
      goToAuth();
    } else {
      window.location.href = MODAK_URL;
    }
  };

  const goToAuth = (): void => {
    navigate('/authentication/sign-up');
  };

  return {logout};
};
